<!--
  Two-column tester layout:
   - Left:  paste a Lottie JSON, see render-side stats, open the dynamics editor.
   - Right: live <ng-lottie> render of whatever was loaded, against the same
            sfl-lottie-web fork the production app uses.
  Everything is template-only on the hot path: the component pre-computes the
  AnimationOptions object whenever the JSON or change set changes.
-->
<div class="lottie-tester">
    <header class="tester-header">
        <h1>Lottie Tester</h1>
        <p class="sub">
            Paste a Lottie JSON, load it, and edit any dynamic identifiers via the
            production editor dialog — same lib, same fork, same renderer the real
            app uses. Use this to reproduce bugs that disagree with the demo.
        </p>
    </header>

    <div class="tester-body">
        <section class="left-col">
            <label class="paste-label" for="json-paste">Lottie JSON</label>
            <textarea
                id="json-paste"
                class="paste-area"
                spellcheck="false"
                placeholder='{"v":"5.12.1","fr":30,"w":1080,"h":1920,"layers":[…]}'
                [(ngModel)]="pastedJson"></textarea>

            <div class="action-row">
                <button class="btn btn-primary" (click)="loadFromTextarea()">Load</button>
                <button class="btn btn-secondary" [disabled]="!hasIdentifiers" (click)="openEditor()">
                    Edit Dynamics
                </button>
                <button class="btn btn-ghost" (click)="clearAll()">Clear</button>
            </div>

            <p class="status" *ngIf="status" [class.ok]="statusKind === 'ok'" [class.err]="statusKind === 'err'">
                {{ status }}
            </p>

            <dl class="info" *ngIf="info">
                <div><dt>Dimensions</dt><dd>{{ info.w }} × {{ info.h }}</dd></div>
                <div><dt>Frames</dt><dd>{{ info.frames }} &#64; {{ info.fps }} fps</dd></div>
                <div><dt>Layers</dt><dd>{{ info.layers }}</dd></div>
                <div><dt>Dynamic identifiers</dt><dd>{{ info.identifiers }}</dd></div>
            </dl>
        </section>

        <section class="right-col">
            <div class="stage" [class.empty]="!options">
                <ng-container *ngIf="options; else emptyTpl">
                    <ng-lottie
                        class="lottie"
                        [options]="options"
                        (animationCreated)="onAnimationCreated($event)"></ng-lottie>
                </ng-container>
                <ng-template #emptyTpl>
                    <div class="empty-msg">Paste a JSON on the left, then click Load.</div>
                </ng-template>
            </div>
        </section>
    </div>
</div>
